var rmsApiProxyRetry = require('../../api/rmsApiProxyRetry');
var dateUtil = require('../../dateUtil/dateUtil');
var logger = require('../../logger/logger');
var stringUtil = require('../../string/stringUtil.js');
var constants = require('../../../utils/domain/constants.js');
var formatter = require('../../../utils/formatter/formatter');
var terminalUtility = require('../../../utils/domain/terminalUtility');
var jobsServer = require('../../../utils/jobs/jobsServer');
var guidUtil = require('../../../utils/guid/guidUtil');

const cardPaymentManagement = constants.externalEntities.cardPaymentManagement;

const defaultStripRetryCount = 3;
const defaultStripeTimeoutInSeconds = [5, 5, 10];
const checkResultTimeInMs = 2000;
const timeoutTransactionInMinute = 10;
var paymentCurrency;
var paymentMetadata;

var connectAccountId;
var readerId;
var currentTransaction;

module.exports.connect = function (creditCardTerminalConfiguration, onConnect, onConnectionError)
{
    try
    {
        if (stringUtil.isStringNullOrEmpty(creditCardTerminalConfiguration.readerId))
            throw Error("Failed to find reader id");

        paymentCurrency = creditCardTerminalConfiguration.paymentCurrency;
        paymentMetadata = creditCardTerminalConfiguration.paymentMetadata;
        connectAccountId = creditCardTerminalConfiguration.connectAccountId;
        readerId = creditCardTerminalConfiguration.readerId;

        let url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/reader/${readerId}`;
        let paymentRequest = {};
        paymentRequest.processor = "StripeReader";
        rmsApiProxyRetry.post(url, paymentRequest, defaultStripRetryCount, null, defaultStripeTimeoutInSeconds)
            .then(result =>
            {
                if (stringUtil.areStringSame(result.status, "online"))
                {
                    onConnect();
                }
                else
                {
                    onConnectionError(`Card reader is not switched on or connected to the internet. Please check the card terminal. Error: ${result.status}`);
                }
            }, error =>
            {
                onConnectionError(error);
            });
    }
    catch (error)
    {
        onConnectionError(error);
    }
}


module.exports.refundAmount = (amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline, chargeId) =>
{
    let url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/refunds`;
    let paymentRequest = {};
    paymentRequest.processor = "StripeReader";
    paymentRequest.refundPayload = {};
    paymentRequest.refundPayload.amount = (amount * 100).toFixed(0);
    paymentRequest.refundPayload.payment_intent = chargeId;
    paymentRequest.refundPayload.refund_application_fee = true;
    paymentRequest.refundPayload.reverse_transfer = true;

    rmsApiProxyRetry.post(url, paymentRequest, defaultStripRetryCount, () => logger.warn(`Refund request for chargeId ${chargeId} taking longer `), defaultStripeTimeoutInSeconds)
        .then(result =>
        {
            if (result.status !== "succeeded")
            {
                onDecline();
                return;
            }

            onSuccessful(convertCreditCardRefundResponseToStandardResponse(result, chargeId, 'refund'));
        }, error =>
        {
            logger.warn(`Error occurred while processing payment: ${error}`, {}, error, cardPaymentManagement.stripeReader);
            onError(`Error occurred while processing payment: ${error}`);
        });
}


module.exports.chargeAmount = (saleId, amount, onStatusMessage, onError, onSignatureVerification, onSignatureVerificationTimeout, onSuccessful, onDecline) =>
{
    let feeAmount = paymentMetadata.transactionFixedFee;
    feeAmount = feeAmount + (amount * paymentMetadata.transactionPercentageFee) / 100;
    feeAmount = ((feeAmount * 100).toFixed(0) / 100);

    const transactionTax = (feeAmount * paymentMetadata.transactionTaxRate/ 100).toFixed(2) * 1
    feeAmount += transactionTax;

    const transfer_data = {};
    transfer_data.destination = connectAccountId;

    var metaData = {};
    metaData.flipdish_store_id = paymentMetadata.payoutStoreId;
    metaData.flipdish_fee_percent = paymentMetadata.transactionPercentageFee;
    metaData.flipdish_fee_fixed = paymentMetadata.transactionFixedFee;
    metaData.transaction_tax_amount = transactionTax;
    metaData.transaction_tax_rate = paymentMetadata.transactionTaxRate;
    metaData.stripe_reader_id = readerId;
    metaData.pos_sale_id = saleId;
    metaData.pos_terminal_id = terminalUtility.getTerminalCode();
    metaData.pos_tip_amount = "0.0";

    var paymentIntent = {
        amount: (amount * 100).toFixed(0),
        currency: paymentCurrency,
        payment_method_types: ['card_present'],
        capture_method: 'automatic',
        on_behalf_of: connectAccountId,
        application_fee_amount: (feeAmount * 100).toFixed(0),
        transfer_data,
        metadata: metaData
    }

    this.startTransaction(paymentIntent, onStatusMessage, onError, onSuccessful, onDecline, 'sale');
}

module.exports.startTransaction = (paymentIntent,onStatusMessage, onError, onSuccessful, onDecline, transactionType) =>
{
    try
    {
        if (currentTransaction != null)
        {
            logger.warn('There is already an ongoing transaction and cannot start a new one', {}, null, cardPaymentManagement.stripeReader);
            onError('There is already an ongoing transaction and cannot start a new one');
        };

        currentTransaction = {};
        currentTransaction.startDateTime = dateUtil.getNow();

        logger.info("Checking device connection status");
        onStatusMessage("Connecting To Device");

        let url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/reader/${readerId}`;
        let paymentRequest = {};
        paymentRequest.processor = "StripeReader";
        rmsApiProxyRetry.post(url, paymentRequest, defaultStripRetryCount, () => logger.warn(`Connect request for reader ${readerId} taking longer`), defaultStripeTimeoutInSeconds)
        .then(result =>
        {
            if (currentTransaction.requireCancellation)
            {
                logger.info("Aborting transaction as customer has cancelled the transaction")
                currentTransaction = null;
                onError("Cancelled");
                return;
            }

            if (stringUtil.areStringSame(result.status, "online"))
            {
                logger.info("Device is online, creating a payment intent");
                onStatusMessage("Contacting Server");

                let url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/paymentIntent`;
                const paymentIntentRequest = {};
                paymentIntentRequest.processor = "StripeReader";
                paymentIntentRequest.paymentIntent = paymentIntent;
                rmsApiProxyRetry.post(url, paymentIntentRequest, defaultStripRetryCount, () => logger.warn(`Payment Intent request taking longer`), defaultStripeTimeoutInSeconds)
                .then(result => 
                {
                    currentTransaction.paymentIntentId = result.id;

                    if (currentTransaction.requireCancellation)
                    {
                        logger.info(`Cancelling transaction as customer has cancelled the transaction for payment intent ${result.id}`);
                        doCancelTransaction();
                        currentTransaction = null;
                        onError("Cancelled");
                        return;
                    }

                    logger.info(`Payment intent created, starting a charge transaction for payment intent ${result.id}`);
                    onStatusMessage("Processing Transaction");

                    url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/charge`;
                    const chargeRequest = {};
                    chargeRequest.processor = "StripeReader";
                    chargeRequest.readerId = readerId;
                    chargeRequest.paymentIntentId = currentTransaction.paymentIntentId;
                    const paymentIntentId = currentTransaction.paymentIntentId;
                    rmsApiProxyRetry.post(url, chargeRequest, defaultStripRetryCount, () => logger.warn(`Charge request for payment intent ${paymentIntentId} request taking longer`), defaultStripeTimeoutInSeconds)
                    .then(result =>
                    {
                        onStatusMessage("Waiting For Customer Response");
                        module.exports.setTimerForTransactionResult(onStatusMessage, onError, onSuccessful, onDecline);
                    }, error => 
                    {
                        doCancelTransaction();
                        currentTransaction = null;
                        logger.error(`Error posting charge request for payment intent ${result.id}. ${error}`, {}, error, cardPaymentManagement.stripeReader);
                        onError(error);
                    })
                }, error =>
                {
                    currentTransaction = null;
                    logger.error(`Error posting paymentIntent, ${error}`, {}, error, cardPaymentManagement.stripeReader);
                    onError(error);
                });
            }
            else
            {
                currentTransaction = null;
                logger.error(`Card reader is not online`, { readerId }, {}, cardPaymentManagement.stripeReader);
                onError(`Card reader is not switched on or connected to the internet. Please check the card terminal.`);
            }
        }, 
        error =>
        {
            currentTransaction = null;
            logger.error(`Error reading card reader status`, { readerId }, error, cardPaymentManagement.stripeReader);
            onError(error);
        });
    }
    catch (error)
    {
        currentTransaction = null;
        logger.warn(`Error occurred in stripe driver while performing transaction: ${error}`, {}, error, cardPaymentManagement.stripeReader);
        onError(error);
    }
}

module.exports.setTimerForTransactionResult = function (onStatusMessage, onError, onSuccessful, onDecline)
{
    window.setTimeout(() =>
    {
        module.exports.getTransactionResult(onStatusMessage, onError, onSuccessful, onDecline);
    }, checkResultTimeInMs);
}

module.exports.getTransactionResult = function (onStatusMessage, onError, onSuccessful, onDecline)
{
    try
    {
        if (currentTransaction == null || stringUtil.isStringNullOrEmpty(currentTransaction.paymentIntentId))
            return;
      
        if (currentTransaction.requireCancellation)
        {
            doCancelTransaction();
            currentTransaction = null;
            onError("Cancelled");
            return;
        }
    
        if (dateUtil.differenceInMinutes(dateUtil.getNow(), currentTransaction.startDateTime) >= timeoutTransactionInMinute)
        {
            doCancelTransaction();
            currentTransaction = null;
            onError("TimeOut");
            return;
        }

        let url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/paymentIntent/${currentTransaction.paymentIntentId}`;
        let paymentIntentStatusRequest = {};
        paymentIntentStatusRequest.processor = "StripeReader";


        const paymentIntentId = currentTransaction.paymentIntentId;
        rmsApiProxyRetry.post(url, paymentIntentStatusRequest, defaultStripRetryCount, () => logger.warn(`Payment Intent status request for ${paymentIntentId} taking longer`), defaultStripeTimeoutInSeconds)
        .then(result => 
        {
            if (result.status === "succeeded")
            {
                var formattedResponse = convertCreditCardChargeResponseToStandardResponse(result.paymentIntent, 'sale');
                currentTransaction = null;
                onSuccessful(formattedResponse);
            }
            else if (result.status === "failed")
            {
                doCancelTransaction();
                currentTransaction = null;
                onDecline();
            }
            else if (result.status === "canceled")
            {
                currentTransaction = null;
                onError("Cancelled");
            }
            else
            {
                logger.info(`Stripe card reader status received as '${result.status}' with message as '${result.statusMessage}'`, {}, cardPaymentManagement.stripeReader);
                if(!stringUtil.isStringNullOrEmpty(result.statusMessage))
                    onStatusMessage(result.statusMessage);
                    
                module.exports.setTimerForTransactionResult(onStatusMessage, onError, onSuccessful, onDecline);
                return;
            }

        }, 
        error =>
        {
            logger.warn(`Error response received in stripe driver while retrieving the transaction result: ${error}`, cardPaymentManagement.stripeReader);
            module.exports.setTimerForTransactionResult(onStatusMessage, onError, onSuccessful, onDecline);
            return;
        })
    }
    catch (error)
    {
        logger.warn(`Error occurred in stripe driver while retrieving the transaction result: ${error}`, {}, error, cardPaymentManagement.stripeReader);
        module.exports.setTimerForTransactionResult(onStatusMessage, onError, onSuccessful, onDecline);
        return;
    }
}

function doCancelTransaction()
{
    const cancelRequest = {};
    cancelRequest.processor = "StripeReader";
    cancelRequest.readerId = readerId;
    cancelRequest.paymentIntentId = currentTransaction.paymentIntentId;
    let url = `${rmsApiProxyRetry.getOrgContextToUrl()}/paymentGateway/cancel`;

    currentTransaction.requireCancellation = false;

    const paymentIntentId = currentTransaction.paymentIntentId;

    jobsServer.addJob(guidUtil.generateGuid(), `BatchJobs.StripeReader.Cancelling paymentIntentId ${paymentIntentId}`,
    () =>
        {
            return rmsApiProxyRetry.post(url, cancelRequest, defaultStripRetryCount, () => logger.warn(`Cancel stripe payment for paymentIntentId ${paymentIntentId}, readerId ${readerId} taking longer `), defaultStripeTimeoutInSeconds);
        }
    );
}


function convertCreditCardChargeResponseToStandardResponse(paymentIntent, transactionType)
{
    var response = {};
    response.driver = "StripeReader";
    response.transactionType = transactionType;
    response.amountTotal = paymentIntent.amount;
    response.transactionDate = paymentIntent.created;
    response.feeAmount = (paymentIntent.application_fee_amount || 0) / 100;

    if (paymentIntent.charges != null && paymentIntent.charges.data != null && paymentIntent.charges.data.length > 0)
    {
        var chargesData = paymentIntent.charges.data[0];
        response.authCode = chargesData.id;
        if (chargesData.payment_method_details != null && chargesData.payment_method_details.card_present != null)
        {
            var cardPresentDetails = chargesData.payment_method_details.card_present;
            response.cardSchemeName = cardPresentDetails.brand;
            response.dateOfExpiry = `${cardPresentDetails.exp_month}/${cardPresentDetails.exp_year}`;
            response.primaryAccountNumber = cardPresentDetails.last4;
            response.cardholderVerificationMethod = cardPresentDetails.read_method;
            response.paymentMethod = cardPresentDetails.read_method;
        }

        if (stringUtil.areStringSame(transactionType, "sale"))
            response.chargeId = chargesData.payment_intent;
    }
    if(paymentIntent.amount_details && paymentIntent.amount_details.tip && paymentIntent.amount_details.tip.amount)
    {
        response.tipAmount = ((paymentIntent.amount_details.tip.amount * 1) / 100).toFixed(2);
    }
    return response;
}



function convertCreditCardRefundResponseToStandardResponse(refundIntent, chargeId, transactionType)
{
    var response = {};
    response.driver = "StripeReader";
    response.transactionType = transactionType;
    response.amountTotal = refundIntent.amount;
    response.transactionDate = refundIntent.created;
    response.chargeId = chargeId;
    return response;
}


module.exports.extractRefundableLines = function (receiptLines)
{
    var responses = [];
    if (receiptLines == null || receiptLines.length <= 0)
        return responses;

    receiptLines.forEach(r =>
    {
        var line = JSON.parse(r.line);
        if (r.type == constants.ReceiptLineTypeCharge && line.mode == constants.PaymentMethodCredit &&
            line.driver == "StripeReader" && !stringUtil.isStringNullOrEmpty(line.chargeId))
        {
            let response = {};
            response.identifier = `xxxx-xxxx-xxxx-${line.primaryAccountNumber}`;
            response.chargeId = line.chargeId;
            response.amount = r.amount;
            response.refunded = 0;
            response.refundable = r.amount;
            responses.push(response);
        }
    });


    receiptLines.forEach(r =>
    {
        var line = JSON.parse(r.line);
        if (r.type == constants.ReceiptLineTypeRefund && line.mode == constants.PaymentMethodCredit &&
            line.driver == "StripeReader" && !stringUtil.isStringNullOrEmpty(line.chargeId))
        {
            let response = responses.find(r => stringUtil.areStringSame(r.chargeId, line.chargeId));
            if (response != null)
            {
                response.refunded = response.refunded + r.amount;
                response.refundable = response.refundable - r.amount;
            }
        }
    });

    responses.forEach(r =>
    {
        r.amount = formatter.roundUp(r.amount, 2)
        r.refunded = formatter.roundUp(r.refunded, 2)
        r.refundable = formatter.roundUp(r.refundable, 2)
    })

    return responses;
}

module.exports.cancelCurrentTransaction = function()
{
    if (currentTransaction == null)
        return;
   
    logger.info("Marking transaction for cancellation on customer request.")
    currentTransaction.requireCancellation = true;
}